import { gql } from "graphql-request";

export const GET_POTENTIAL_OPPORTUNITIES = gql`
  query DashboardPotentialOpportunities(
    $dashboardPotential: DashboardPotentialInput
  ) {
    dashboardPotentialOpportunities(dashboardPotential: $dashboardPotential) {
      data {
        data {
          customValue
          manufacturer
          tariffDuty
          tariffValue
        }
        total {
          customsDuty
          customsValue
          percentCustomValue
        }
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_POTENTIAL_VENDORS = gql`
  query DashboardPotentialVendors(
    $dashboardPotential: DashboardPotentialVendorInput
  ) {
    dashboardPotentialVendors(dashboardPotential: $dashboardPotential) {
      data {
        data {
          customValue
          manufacturer
          tariffDuty
          tariffValue
        }
        total {
          customsDuty
          customsValue
          percentCustomValue
        }
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_ALL_VENDORS = gql`
  query GetFirstSaleData($vendorsInput: GetFirstSaleInput) {
    getFirstSaleData(vendorsInput: $vendorsInput) {
      data {
        tradeData {
          manufacturer
          manufacturerName
          tariffValue
          tariffDuty
          customValue
          relatedPartyIndicator
          submissionStatus {
            _id
            clientId
            tenantId
            manufacturerId
            manufacturerName
            manufacturerEmail
            manufacturerHtsNumber
            manufacturerImporterId
            status
            supplierResponse {
              step1 {
                sentDate
              }
              step2 {
                responses {
                  heading
                  description
                  sentDate
                  response
                }
                responseDate
              }
              step3 {
                validationDate
                reportStatus
                reportUrl
              }
              step4 {
                engagementDate
              }
            }
          }
          isManufacturer
          isExporter
          isRelated
        }
        total {
          customsDuty
          customsValue
          percentCustomValue
        }
      }
    }
  }
`;

export const GET_POTENTIAL_RELATED_VENDORS = gql`
  query DashboardPotentialRelatedUnrelatedVendors(
    $dashboardPotential: DashboardPotentialInput
  ) {
    dashboardPotentialRelatedUnrelatedVendors(
      dashboardPotential: $dashboardPotential
    ) {
      data {
        data {
          customValue
          manufacturer
          tariffDuty
          tariffValue
        }
        total {
          customsDuty
          customsValue
          percentCustomValue
        }
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_POTENTIAL_ORIGIN_VS_MANUFACTURER = gql`
  query DashboardPotentialOriginVsManufacturerId(
    $dashboardPotential: DashboardPotentialInput
  ) {
    dashboardPotentialOriginVsManufacturerId(
      dashboardPotential: $dashboardPotential
    ) {
      data {
        data {
          customValue
          manufacturer
          tariffDuty
          tariffValue
        }
        total {
          customsDuty
          customsValue
          percentCustomValue
        }
      }
    }
  }
`;

export const GET_POTENTIAL_ORIGIN_VS_EXPORT = gql`
  query DashboardPotentialOriginVsExport(
    $dashboardPotential: DashboardPotentialInput
  ) {
    dashboardPotentialOriginVsExport(dashboardPotential: $dashboardPotential) {
      data {
        data {
          customValue
          manufacturer
          tariffDuty
          tariffValue
        }
        total {
          customsDuty
          customsValue
          percentCustomValue
        }
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_POTENTIAL_FTZ_SAVINGS = gql`
  query DashboardPotentialFTZSavings(
    $dashboardPotential: DashboardPotentialInput
  ) {
    dashboardPotentialFTZSavings(dashboardPotential: $dashboardPotential) {
      data {
        entryNumber
        entryDate
        portOfEntry
        lineCount
        mpf
        totalLineMPF
        totalDuties
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_POTENTIAL_MTB_SAVINGS = gql`
  query DashboardPotentialMTBSavings(
    $dashboardPotential: DashboardPotentialInput
  ) {
    dashboardPotentialMTBSavings(dashboardPotential: $dashboardPotential) {
      data {
        htsCode
        mtbNumber
        oldDutyRate
        newDutyRate
        savings
        goodsValue
        description
        status
        expirationDate
        entryCount
      }
      total {
        totalSavings
        totalGoodsValue
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_POTENTIAL_EXCLUSION_SAVINGS = gql`
  query DashboardPotentialExclusionSavings(
    $dashboardPotential: DashboardPotentialInput
  ) {
    dashboardPotentialExclusionSavings(
      dashboardPotential: $dashboardPotential
    ) {
      data {
        htsCode
        code99
        oldDutyRate
        newDutyRate
        savings
        goodsValue
        description
        entryCount
        active
      }
      total {
        totalSavings
        totalGoodsValue
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;
export const MUTATE_SEND_FIRST_SALE_EMAIL = gql`
  mutation SendEmailToManufacturer(
    $manufacturerId: String!
    $to: String
    $clientId: String!
    $tenantId: String
    $manufacturerSubmissionId: String
  ) {
    sendEmailToManufacturer(
      manufacturerId: $manufacturerId
      to: $to
      clientId: $clientId
      tenantId: $tenantId
      manufacturerSubmissionId: $manufacturerSubmissionId
    ) {
      data {
        msg
        status
      }
    }
  }
`;

export { GET_PREF_ORIGIN_OPPORTUNITIES } from "./prefOrigin";
